import React, { ChangeEvent } from 'react';
import { Input } from 'antd';
import styled from 'styled-components';
import TextArea from 'antd/lib/input/TextArea';

const InputWrapper = styled.div<{ width?: string; border?: string; borderRadius: string; padding?: string; bgColor?: string; color?: string }>`
  flex: 1;
  .global-input {
    max-height: 38px;
    height: 38px;
    cursor: pointer;
    font-size: 16px;
    width: ${(props) => props.width};
    border: ${(props) => props.border || '1px solid #DADADA'};
    color: ${(props) => props.color || '#C1C1C1'};
    background: ${(props) => props.bgColor || '#fff'};
    border-radius: ${(props) => props.borderRadius || '4px'};
    padding: ${(props) => props.padding};
    font-weight: 500;
    font-family: 'Roboto';
    color: #7e7e7e;
    &::placeholder {
      color: #c1c1c1 !important;
      font-family: 'Roboto' !important;
      font-size: 16px !important;
      font-style: italic !important;
      font-weight: 400 !important;
      line-height: 20px !important; /* 125% */
      letter-spacing: -0.36px !important;
      @media all and (max-width: 1439px) and (max-height: 729px) and (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px !important;
      }
      @media all and (max-width: 1024px) and (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px !important;
      }
    }
  }
`;

const TextareaWrapper = styled.div<{ border?: string; width?: string; borderRadius: string; padding?: string; bgColor?: string; color?: string }>`
  flex: 1;
  .global-input {
    max-height: 38px;
    font-weight: 400;
    width: ${(props) => props.width};
    border: ${(props) => props.border || '1px solid #DADADA'};
    color: ${(props) => props.color || '#C1C1C1'};
    background: ${(props) => props.bgColor || '#fff'};
    border-radius: ${(props) => props.borderRadius || '4px'};
    padding: ${(props) => props.padding};
    font-family: 'Roboto';
  }
`;

interface CommonProps {
  width: string;
  placeholder: string;
  value: string;
  onPressEnter: () => void;
  bgColor: string;
  border: string;
  color: string;
  borderRadius: string;
  padding: string;
  prefix: React.ReactChild;
  inputType: 'input' | 'textarea';
}

interface InputProps extends CommonProps {
  size: 'small' | 'large';
  handleInputChange: (e: ChangeEvent<HTMLInputElement>) => void;
  suffix: React.ReactChild;
}

interface TextareaProps extends CommonProps {
  maxLength: number;
  rows: number;
}

type InputOrTextareaProps = InputProps | TextareaProps;

const GlobalInput: React.FC<InputOrTextareaProps> = (props) => {
  if (props.inputType === 'input') {
    // Use InputProps
    const { width, size, placeholder, prefix, handleInputChange, value, onPressEnter, border, borderRadius, bgColor, color, padding, suffix } =
      props as InputProps;

    return (
      <InputWrapper width={width} border={border} borderRadius={borderRadius} bgColor={bgColor} color={color} padding={padding}>
        <Input
          size={size}
          placeholder={placeholder}
          prefix={prefix}
          suffix={suffix}
          className="global-input"
          id="input"
          onChange={handleInputChange}
          value={value}
          onPressEnter={onPressEnter}
        />
      </InputWrapper>
    );
  } else if (props.inputType === 'textarea') {
    // Use TextareaProps
    const { width, placeholder, value, onPressEnter, maxLength, rows, border, borderRadius, bgColor, color, padding } = props as TextareaProps;

    return (
      <TextareaWrapper width={width} border={border} borderRadius={borderRadius} bgColor={bgColor} color={color} padding={padding}>
        <TextArea rows={rows} placeholder={placeholder} maxLength={maxLength} onPressEnter={onPressEnter} value={value} />
      </TextareaWrapper>
    );
  }

  return null; // Handle other cases if needed
};

export default GlobalInput;
